import background from './background.mjs'
import {
  imgproxySettings,
  mobileImgproxySettings,
  getSKUWithoutPrefix,
  resolvePaceOptionsFromSKU as resolveOptionsFromSKU,
} from './shared.mjs'

import { lenses, reflection, iris } from './velans2.mjs'

export const ghost = {
  id: 'ghost',
  name: 'Ghost Frame',
  hasOptions: false,
  imgproxySettings,
  mobileImgproxySettings,
  opacity: 1,
  pathTemplate: 'gs://sg360/260416/velans2/ghostUpdate/velans2-ghost_{nnn}.png',
}

function resolveOptions(customisedProduct) {
  return {
    engraving: 'eN',
    lens: getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech),
    iris: getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech),
    reflections: 'r5pcTF',
  }
}

export default {
  layers: [background, ghost, lenses, iris, reflection],
  resolveOptions,
  resolveOptionsFromSKU,
}
